"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOfficeUsageSubformFullCostResults = void 0;
const _1 = require(".");
const utils_1 = require("./utils");
const calculateHomeOfficeExpenses = (inputs) => {
    const { monthsUsed, officeArea, totalHomeArea, homeOwnershipType, usagePeriodOperatingHomeExpenses, annualOtherHomeExpenses, annualOtherOfficeExpenses, } = inputs;
    const usagePeriodShare = monthsUsed / 12;
    const usagePeriodRentOrDepreciation = homeOwnershipType === _1.HomeOwnershipType.RENTAL
        ? inputs.monthlyRent * monthsUsed
        : inputs.annualHomeDepreciation * usagePeriodShare;
    const usagePeriodOtherHomeExpenses = annualOtherHomeExpenses * usagePeriodShare;
    const usagePeriodHomeExpenses = usagePeriodRentOrDepreciation +
        usagePeriodOperatingHomeExpenses +
        usagePeriodOtherHomeExpenses;
    const usagePeriodOtherOfficeExpenses = annualOtherOfficeExpenses * usagePeriodShare;
    const officeAreaShare = officeArea / totalHomeArea;
    const homeOfficeExpenses = Math.round(usagePeriodHomeExpenses * officeAreaShare + usagePeriodOtherOfficeExpenses);
    return homeOfficeExpenses;
};
const calculatePaidInputTax = ({ officeArea, totalHomeArea, paidHomeExpensesInputTax16, paidHomeExpensesInputTax19, paidOfficeExpensesInputTax16, paidOfficeExpensesInputTax19, }) => {
    const officeAreaShare = officeArea / totalHomeArea;
    const paidInputTax = Math.round((paidHomeExpensesInputTax16 + paidHomeExpensesInputTax19) *
        officeAreaShare) +
        paidOfficeExpensesInputTax16 +
        paidOfficeExpensesInputTax19;
    return paidInputTax;
};
const calculateOfficeUsageSubformFullCostResults = (inputs) => {
    (0, utils_1.validateOfficeUsageInputs)(inputs);
    const homeOfficeExpenses = calculateHomeOfficeExpenses(inputs);
    const paidInputTax = calculatePaidInputTax(inputs);
    return {
        homeOfficeExpenses,
        paidInputTax,
        profitReduction: homeOfficeExpenses + paidInputTax,
    };
};
exports.calculateOfficeUsageSubformFullCostResults = calculateOfficeUsageSubformFullCostResults;
//# sourceMappingURL=fullCost.js.map